import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';

type ConnectorSyncStatusType = {
  connectorsSyncStatus: { [k: string]: string | undefined };
  setConnectorSyncStatus: (
    installId: string,
    value: string | undefined
  ) => void;
};

export const ConnectorSyncStatusContext = createContext<ConnectorSyncStatusType>(
  {
    connectorsSyncStatus: {},
    setConnectorSyncStatus: () => {}
  }
);

export const useConnectorSyncStatusContext = (): ConnectorSyncStatusType =>
  useContext(ConnectorSyncStatusContext);

const ConnectorSyncStatusContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [connectorsSyncStatus, setConnectorsSyncStatus] = useState({});
  const setConnectorSyncStatus = useCallback(
    (installId: string, value: string | undefined) => {
      setConnectorsSyncStatus((connectorsSyncStatus) => ({
        ...connectorsSyncStatus,
        [installId]: value
      }));
    },
    [setConnectorsSyncStatus]
  );

  const value = useMemo(() => {
    return {
      connectorsSyncStatus: connectorsSyncStatus,
      setConnectorSyncStatus
    };
  }, [connectorsSyncStatus, setConnectorSyncStatus]);

  return (
    <ConnectorSyncStatusContext.Provider value={value}>
      {children}
    </ConnectorSyncStatusContext.Provider>
  );
};

export default ConnectorSyncStatusContextProvider;
